import { render, staticRenderFns } from "./AccessPointControllerList.vue?vue&type=template&id=2efd9742&scoped=true"
import script from "./AccessPointControllerList.vue?vue&type=script&lang=js"
export * from "./AccessPointControllerList.vue?vue&type=script&lang=js"
import style0 from "./AccessPointControllerList.vue?vue&type=style&index=0&id=2efd9742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd9742",
  null
  
)

export default component.exports